import React from "react";
import { useFormContext } from "react-hook-form";
import { Button, Loader } from "rsuite";

const SubmitButton = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const form = useFormContext();

  return (
    <Button
      appearance="primary"
      className={`btn-primary ${className}`}
      type="submit"
    >
      {form.formState.isSubmitting ? <Loader /> : children}
    </Button>
  );
};

export default SubmitButton;
